import React from 'react';

export const FinCheckSettingIcon = ({ className }) => (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M42.2 15.6C43.5 12.3 46.5 10 50 10C53.5 10 56.5 12.3 57.8 15.6L59.1 19.1C59.7 20.6 61.3 21.6 62.9 21.6H66.8C70.3 21.6 73.2 24.5 73.2 28V31.9C73.2 33.5 74.2 35.1 75.7 35.7L79.2 37C82.5 38.3 84.8 41.3 84.8 44.8V55.2C84.8 58.7 82.5 61.7 79.2 63L75.7 64.3C74.2 64.9 73.2 66.5 73.2 68.1V72C73.2 75.5 70.3 78.4 66.8 78.4H62.9C61.3 78.4 59.7 79.4 59.1 80.9L57.8 84.4C56.5 87.7 53.5 90 50 90C46.5 90 43.5 87.7 42.2 84.4L40.9 80.9C40.3 79.4 38.7 78.4 37.1 78.4H33.2C29.7 78.4 26.8 75.5 26.8 72V68.1C26.8 66.5 25.8 64.9 24.3 64.3L20.8 63C17.5 61.7 15.2 58.7 15.2 55.2V44.8C15.2 41.3 17.5 38.3 20.8 37L24.3 35.7C25.8 35.1 26.8 33.5 26.8 31.9V28C26.8 24.5 29.7 21.6 33.2 21.6H37.1C38.7 21.6 40.3 20.6 40.9 19.1L42.2 15.6Z" fill="#2563EB" />
        <circle cx="50" cy="50" r="15" fill="white" />
        <path d="M45 50L48 53L55 46" stroke="#2563EB" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="75" cy="75" r="18" fill="white" stroke="#2563EB" strokeWidth="4" />
        <path d="M68 75L72 79L82 69" stroke="#2563EB" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const FinCheckTemplateIcon = ({ className }) => (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="20" y="15" width="55" height="70" rx="6" fill="white" />
        <rect x="30" y="28" width="10" height="10" stroke="#2563EB" strokeWidth="3" />
        <rect x="42" y="28" width="10" height="10" stroke="#2563EB" strokeWidth="3" />
        <rect x="54" y="28" width="10" height="10" stroke="#2563EB" strokeWidth="3" />
        <rect x="30" y="40" width="10" height="10" stroke="#2563EB" strokeWidth="3" />
        <rect x="42" y="40" width="10" height="10" stroke="#2563EB" strokeWidth="3" />
        <rect x="54" y="40" width="10" height="10" stroke="#2563EB" strokeWidth="3" />
        <path d="M65 65L85 85L75 88L62 72L65 65Z" fill="#2563EB" />
        <path d="M78 68L85 62L92 69L86 76" fill="#2563EB" />
        <path d="M60 62L70 52" stroke="#2563EB" strokeWidth="4" strokeLinecap="round" />
    </svg>
);

export const InspectionIcon = ({ className }) => (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="45" cy="40" r="25" stroke="#2563EB" strokeWidth="7" />
        <path d="M63 58L85 80" stroke="#2563EB" strokeWidth="10" strokeLinecap="round" />
        <path d="M40 30L50 30L50 50L40 50Z" fill="#2563EB" />
        <circle cx="75" cy="55" r="18" fill="#10B981" />
        <path d="M67 55L72 60L83 48" stroke="white" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const UploadIcon = ({ className }) => (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25 60C15 60 10 52 10 44C10 36 16 30 24 30C26 18 36 10 48 10C60 10 70 18 73 30C82 30 90 38 90 48C90 58 82 65 72 65L25 65" stroke="#2563EB" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M50 35L50 60M50 35L40 45M50 35L60 45" stroke="#2563EB" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="30" y="75" width="40" height="8" rx="4" fill="#E2E8F0" />
        <rect x="30" y="75" width="25" height="8" rx="4" fill="#2563EB" />
        <text x="50" y="95" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#2563EB" fontFamily="sans-serif">Upload</text>
    </svg>
);

export const FinCheckReportIcon = ({ className }) => (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 70L20 20M20 70L80 70" stroke="white" strokeWidth="5" strokeLinecap="round" />
        <rect x="30" y="45" width="8" height="20" fill="white" />
        <rect x="45" y="30" width="8" height="35" fill="white" />
        <rect x="60" y="50" width="8" height="15" fill="white" />
        <circle cx="75" cy="35" r="20" fill="white" />
        <path d="M75 35L75 15A20 20 0 0 1 95 35L75 35" fill="#2563EB" />
        <circle cx="75" cy="35" r="5" fill="#2563EB" />
    </svg>
);

export const P88LegacyIcon = ({ className }) => (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 25C10 21 13 18 17 18H35L42 28H83C87 28 90 31 90 35V75C90 79 87 82 83 82H17C13 82 10 79 10 75V25Z" fill="white" stroke="#2563EB" strokeWidth="4" />
        <path d="M10 35H90" stroke="#2563EB" strokeWidth="4" />
        <rect x="25" y="45" width="6" height="20" fill="#EF4444" />
        <rect x="35" y="52" width="6" height="13" fill="#EF4444" opacity="0.7" />
        <rect x="45" y="40" width="6" height="25" fill="#EF4444" opacity="0.9" />
        <text x="70" y="65" textAnchor="middle" fontSize="18" fontWeight="black" fill="#2563EB" fontFamily="sans-serif">P88</text>
    </svg>
);
